import React from "react"
import { useContent } from "@thoughtbot/superglue"

import { DeveloperDocsLayout, type DeveloperDocsPage } from "@javascript/components/developer-docs/DeveloperDocsLayout"
import { VersioningPage } from "@javascript/components/developer-docs/VersioningPage"

interface VersioningContent {
  pages: DeveloperDocsPage[]
}

export default function Versioning() {
  const { pages } = useContent<VersioningContent>()

  return (
    <DeveloperDocsLayout pages={pages} currentHref="/developers/versioning">
      <VersioningPage />
    </DeveloperDocsLayout>
  )
}
